import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {
  CreateLevelModal,
  EditLevelModal,
  LevelListFilters,
} from "@modules/levels/components";

import { useLevelList } from "./controller";
import { useLevelListColumns } from "./columns";

export const LevelList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createLevelModalRef,
    editLevelModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useLevelList();

  const columns = useLevelListColumns(refetch, translate, editLevelModalRef);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <LevelListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="levels.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createLevelModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateLevelModal
        onComplete={() => {
          refetch();
        }}
        modalRef={createLevelModalRef}
      />
      <EditLevelModal
        onComplete={() => {
          refetch();
        }}
        modalRef={editLevelModalRef}
      />
    </List>
  );
});
